// Tokenul de acces pe fiecare cerere catre API (CODE_REVIEW 1.1).
// Pana acum il punea fiecare serviciu in axios.defaults la primul lui apel, asa ca un ecran
// deschis direct (de exemplu /Users dupa refresh) trimitea cererea fara token si primea 401.

// Tokenul pleaca doar catre adresa API-ului, nu si catre alte adrese cerute cu axios.
// Inlocuieste orice antet Authorization pus de servicii (unele trimit "token ...").
export const createAuthInterceptor =
  ({ baseURL, getToken }) =>
  async (config) => {
    if (
      !config ||
      typeof config.url !== "string" ||
      !config.url.startsWith(baseURL)
    ) {
      return config;
    }

    const token = await getToken();
    if (token) {
      config.headers = {
        ...(config.headers || {}),
        Authorization: `Bearer ${token}`,
      };
    }

    return config;
  };

// Tokenul din SDK-ul Auth0 e reinnoit cand expira. Cel din store e pus o singura data de App.vue
// si poate lipsi la primele cereri dupa un refresh, asa ca e folosit doar cand SDK-ul nu e gata.
export const createTokenResolver =
  ({ getAuth, store }) =>
  async () => {
    const auth = getAuth();
    if (auth && auth.auth0Client && auth.isAuthenticated) {
      try {
        return await auth.getTokenSilently();
      } catch (error) {
        // se foloseste tokenul din store
      }
    }

    return store.state.token;
  };
